import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/$slug/processes/all-processes')({
  component: Outlet
});
